import styled from "styled-components";
import {
  BORDER_COLORS,
  COLORS,
  ICON_COLORS,
  LAYER_COLORS,
  TEXT_COLORS,
} from "../../../../constants/design/colors";
import { FONT_CSS } from "../../../../constants/design/fontSize";
import {
  BORDER_RADIUS,
  SPACING,
} from "../../../../constants/design/spacing";

export const Username = styled.div`
  ${FONT_CSS.body.five}
  color: ${TEXT_COLORS.three};
  display: flex;
  align-items: center;
`;

export const UsernameEditButton = styled.button`
  background: none;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin-left: ${SPACING.one}px;
  cursor: pointer;
  color: ${ICON_COLORS.three};

  svg {
    width: 12px;
    height: 12px;
    stroke: currentColor;
  }

  &:hover {
    color: ${TEXT_COLORS.one};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const UsernameEditForm = styled.form`
  display: inline-flex;
  align-items: center;
  gap: ${SPACING.one}px;
  margin-left: ${SPACING.one}px;
`;

export const UsernameEditWrapper = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
`;

export const UsernameError = styled.div<{ $visible: boolean }>`
  ${FONT_CSS.body.five}
  margin-top: ${SPACING.one}px;
  color: ${COLORS.negative.one};
  text-align: center;
  white-space: nowrap;
  visibility: ${({ $visible }) => ($visible ? "visible" : "hidden")};
  /* Reserve a line so the modal height doesn't shift when the error toggles. */
  min-height: 1em;
`;

export const UsernameInput = styled.input`
  ${FONT_CSS.body.five}
  color: ${TEXT_COLORS.one};
  background: ${LAYER_COLORS.one};
  border: 1px solid ${BORDER_COLORS.one};
  border-radius: ${BORDER_RADIUS.two}px;
  padding: 2px ${SPACING.one}px;
  width: 140px;
  outline: none;

  &:focus {
    border-color: ${COLORS.highlight.one};
  }
`;

export const TooltipWrapper = styled.div<{ $stroke?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding-left: ${SPACING.one}px;
  svg {
    stroke: ${({ $stroke }) => $stroke ?? ICON_COLORS.three};
  }
`;
